import { LoadAllSurgicalOrdersByDoctor } from 'domain/usecases/doctor/load-all-surgical-order'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadAllSurgicalOrderByDoctor
  implements LoadAllSurgicalOrdersByDoctor
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  loadAllOrders(
    params: LoadAllSurgicalOrdersByDoctor.Params
  ): Promise<LoadAllSurgicalOrdersByDoctor.Model> {
    return this.doctorRepository.loadAllSurgicalOrdersByDoctor(params)
  }
}
